import React from "react";
import { GiftIcon, RefreshCwIcon, SearchIcon, WrenchIcon, ZapIcon, BoxIcon } from "lucide-react";
import { differentiators } from "../data/content";
import { DifferentiatorIcon } from "../types/content";
const ICONS: Record<DifferentiatorIcon, BoxIcon> = {
  wrench: WrenchIcon,
  search: SearchIcon,
  zap: ZapIcon,
  gift: GiftIcon,
  refresh: RefreshCwIcon
};
export function Differentiators() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-30" data-mp="zdiuw8bxzous">
      <div className="mx-auto max-w-2xl text-center" data-id="element-31" data-mp="zf3onvqfn3rl">
        <h2 className="text-[1.1rem] font-black uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-32" data-mp="13fdsp2unzk3t">
          THIS ISN'T JUST ANOTHER EQUIPMENT REPAIR EBOOK
        </h2>
        <p className="mt-0.5 font-heading text-[0.76rem] font-extrabold uppercase tracking-wide text-electric sm:text-[0.92rem]" data-id="element-33" data-mp="1dc8npbrqb2dc">
          IT'S A READY-TO-USE PROFESSIONAL DIAGNOSTIC SYSTEM.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-34" data-mp="2or5spv4b626c">
          {differentiators.map((item, i) => {
          const Icon = ICONS[item.icon];
          const isLastOdd = i === differentiators.length - 1 && differentiators.length % 2 === 1;
          return <div key={item.title} className={`rounded-md border border-navy/10 bg-ice px-2.5 py-2 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-35" data-mp="7l4gh0rxo1fk" data-mpi={i}>
                <h3 className="flex items-center gap-1.5 text-[0.78rem] font-extrabold text-navy sm:text-[0.9rem]" data-id="element-36" data-mp="3tuyr1w29ubqn">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-electric" strokeWidth={2.25} aria-hidden="true" data-id="element-37" data-mp="3owdz0jx6ayda" />
                  {item.title}
                </h3>
                <p className="mt-0.5 text-[0.76rem] leading-[1.35] sm:text-[0.86rem]" data-id="element-38" data-mp="3g324e7jdgu1n">{item.body}</p>
              </div>;
        })}
        </div>
        <p className="mt-2 font-heading text-[0.74rem] font-extrabold uppercase tracking-wide text-navy sm:text-[0.88rem]" data-id="element-39" data-mp="3b58w98yidpyq">
          Less searching. Less guessing. <span className="text-electric" data-id="element-40" data-mp="315rvn5y4629m">More diagnostic clarity.</span>
        </p>
      </div>
    </section>;
}